/**
 * Perform node.js environment check once and for all
 */
const isRunningInNode = (
    typeof global !== "undefined" && // tslint:disable-line no-typeof-undefined
    typeof global.process !== "undefined" && // tslint:disable-line no-typeof-undefined
    Object.prototype.toString.call(global.process) === "[object process]"
);

/**
 * Helper that returns the result of the node.js check carried out above
 * publicly.
 */
export function isNode(): boolean {
    return isRunningInNode;
}
